<template>
  <div>
    <div class="mb-4 d-flex align-items-center justify-content-between" style="flex-wrap: wrap;">
        <div class="d-flex align-items-center justify-content-start" style="flex-wrap: wrap;">
            <h3 class="title my-1">Members</h3>
            <button v-if="canUserModify" data-toggle="modal" data-target="#addMemberModal" class="ml-2 my-1 btn btn-sm btn-primary text-white my-0">
                <ion-icon name="ios-add-circle" class="text-white"></ion-icon>
                <span>Add member</span>
            </button>
        </div>
        <input class="my-1 form-control form-control-sm" v-model="query" placeholder="Filter by name" />
    </div>

    <div class="card">
        <div class="card-body px-4 py-2">
            <div v-for="(member, index) in filteredMembers" :key="member._id">
                <div class="d-flex justify-content-start my-3">
                    <div class="mr-3">
                        <img v-if="member.profile.upload && member.profile.upload.path" class="rounded-circle" width="72" height="72" :src="member.profile.upload.path" alt />
                        <img v-else class="rounded-circle" width="72" height="72" src="../../../assets/avatar.png"/>
                    </div>
                    <div class="d-flex justify-content-start flex-column w-100">
                        <h6>
                            <router-link :to="'/profile/' + member.profile_id" class="content-header__name">{{ member.profile.name }}</router-link>
                            <br>
                            <small class="text-muted text-capitalize">{{ getRole(member) }}</small> &middot;
                            <small class="text-muted">Joined {{ getDateJoined(member) }}</small>
                        </h6>
                        <p v-if="isUserAdmin">
                            Phone &middot; <span class="text-muted">{{getContact(member.profile)}}</span> <br>
                            Email &middot; {{member.profile.email}}
                        </p>
                        <div v-if="member.profile.profile_identities.length">
                            <div>
                                <div v-for="pid in profileCircleIdentity[member.profile._id]" :key="pid.identity._id">{{pid.identity.title}} &middot; <span class="text-muted">{{pid.profile.value}}</span> </div>
                            </div>
                        </div>
                        <!-- horizontal line -->
                        <div v-if="index !== filteredMembers.length-1" class="mt-3 border-top"></div>
                    </div>
                </div> 
            </div>

        </div>
    </div>
    
  <div class="auth-modal">
    <div class="modal fade" id="addMemberModal" tabindex="-1" role="dialog" aria-labelledby="addMemberModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header pb-0 border-0">
            <div>
                <h5 class="title my-0">Add member to circle</h5>
                <small class="text-muted">Add member to your circle using their phone number</small>
            </div>
          </div>
          <div class="modal-body pt-3">
            <div class="d-flex align-items-center justify-content-start" style="flex-wrap: wrap">
                <div class="form-group" style="max-width: 50%">
                    <label>
                        <small class="text-muted">Member phone number</small>
                    </label>
                    <select v-model="selectedCountryCode" name="country" id="country" class="form-control" style="max-width: 90%">
                        <option v-for="country in countries" :key="country.code" :value="country.dial_code">
                        <b>{{country.name}}</b>
                        </option>
                    </select>
                </div>
                <div class="form-group" style="max-width: 50%">
                    <span class="country-code">{{selectedCountryCode}}</span>
                    <input v-model="addMember.phone" id="phone" type="tel" placeholder="XXXXXXXXXXX" class="form-control" maxlength="15"/>
                </div>
            </div>
            <div class="mt-3 d-flex align-items-center justify-content-start">
                <div class="form-group">
                    <label>
                        <small class="text-muted">Role</small>
                    </label>
                    <select v-model="addMember.role" class="form-control">
                        <option :value="null">Select a role</option>
                        <option value="default">Member</option>
                        <option value="administrator">Administrator</option>
                        <option value="editor">Editor</option>
                    </select>
                </div>
            </div>
            <div class="mt-3 d-flex align-items-center justify-content-end" style="flex-wrap: wrap">
                <button id="addMemberDismissBtn" @click="resetForm()" data-dismiss="modal" class="btn btn-light mr-2 my-1 btn-sm">Cancel</button>
                <button @click="submit($event)" :disabled="!formValid" class="btn btn-primary my-1 btn-sm">Add to circle</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
    import CircleService from "@/services/circle";
    import * as countries from "@/constants/countries";
    const PhoneNumber = require('awesome-phonenumber');

    const circleService = new CircleService();

    export default {
        name: "CircleMemberList",
        props: ["members", "circle_id", "isUserAdmin", "contentLoading", "user", "identities", "circleIdentities"],
        data() {
            return {
                memberList: [],
                query: null,
                addMember: {
                    phone: '',
                    role: 'default'
                },
                selectedCountry: null,
                fullPhone: "",
                selectedCountryCode: countries.data.find(country => country.name.toLowerCase() === "nigeria").dial_code,
                countries: countries.data,
                phoneValid: false
            }
        },
        methods: {
            getContact(profile) {
                let contact = '';

                if (profile.phone[0] === '+') {
                    contact = profile.phone;
                } else if (profile.email && !profile.email.includes('@fauxinfodemics.com')) {
                    contact = profile.email
                }

                return contact;
            },
            getRole(member) {
                let role = '';

                if (member.type === "role") {
                    if (member.status === 'default') {
                        role = 'member';
                    } else {
                        role = member.status;
                    }
                }
                return role;
            },
            getDateJoined(member) {
                const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

                const d = new Date(member.created * 1000), yyyy = d.getUTCFullYear(), mm = d.getUTCMonth(), dd = d.getUTCDate();
                let date, m = months[mm], ddd = `${dd}`;

                if (dd < 10) {
                    ddd = `0${dd}`;
                }

                return `${ddd} ${m} ${yyyy}`;
            },
            canRemoveMember(member) {
                return this.canUserModify && (this.getRole(member) !== 'administrator' && this.getRole(member) !== 'owner');
            },
            resetForm() {
                this.addMember = { phone: "", role: 'default' }
                this.fullPhone = "";
                this.selectedCountry = null;
                this.phoneValid = false;
            },
            submit(e) {
                const closeBtn = document.getElementById('addMemberDismissBtn');
                const btn = e.srcElement;

                btn.disabled = true;
                btn.innerText = 'Processing';
                btn.classList.add("btn--loading");

                circleService.addUserToCircleUsingPhone(this.fullPhone, this.addMember.role, this.$props.circle_id).then(board => {
                    this.$root.$emit('AddNewMemberToCircle', { circle_id: this.$props.circle_id, board });
                    this.$notification.new(`Member added to circle`);

                    closeBtn.click();
                    this.resetForm();
                    
                    btn.disabled = false;
                    btn.innerText = "Add to circle";
                    btn.classList.remove("btn--loading");
                }).catch(err => {
                    btn.disabled = false;
                    btn.innerText = "Add to circle";
                    btn.classList.remove("btn--loading");

                    (err && err.message) ? (this.$root.$emit("ShowErrorNotification", err.message)) : 
                    (this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again."));
                })
            },
            removeMember(member, e) {
                const submitBtn = e.srcElement;
                swal({
                    text: `Remove ${member.profile.name} from this circle?`,
                    icon: "warning",
                    buttons: true,
                    dangerMode: true
                }).then((removeMember) => {
                    if (removeMember) {
                        const defaultBtnText = submitBtn.innerText;
                        
                        submitBtn.classList.add("btn--loading");
                        submitBtn.disabled = true;
                        submitBtn.innerText = 'Processing';

                        circleService.removeMember(member, this.$props.identities).then(() => {
                            this.$notification.new(`${member.profile.name} has been removed from this circle`);
                            this.$root.$emit("RemoveMemberFromCircle", member);
                        }).catch(err => {
                            submitBtn.classList.remove("btn--loading");
                            submitBtn.disabled = false;
                            submitBtn.innerText = defaultBtnText;
                            this.$root.$emit("ShowErrorNotification", err.message);
                        });
                    }
                })
            },
        },
        computed: {
            filteredMembers: function() {
                return this.query ? this.memberList.filter(s => s.profile.name.toLowerCase().includes(this.query.toLowerCase())) : this.memberList;
            },
            formValid: function() {
                return this.addMember.role && this.phoneValid;
            },
            canUserModify() {
                return this.$props.isUserAdmin &&
                    this.$props.members.find(s => s.profile_id === this.$props.user._id && s.status === 'administrator' || s.status === 'owner');
            },
            profileCircleIdentity() {
                let compounded = [];
                let arranged = {}
                this.$props.identities.map(item => {
                    let pid = item.profiles.map(profile => {
                        compounded.push({
                            identity: item,
                            profile: profile
                        })
                    })
                })
                compounded.map(item => {
                    if(arranged[item.profile.profile_id]) {
                        arranged[item.profile.profile_id].push(item)
                    } else {
                        arranged[item.profile.profile_id] = []
                        arranged[item.profile.profile_id].push(item)
                    }
                })
                return arranged;
            }
        },
        watch: {
            "selectedCountryCode": {
                handler: function(val) {
                    this.selectedCountry = this.countries.find(country => country.dial_code === val);
                    const phone = new PhoneNumber(this.addMember.phone, this.selectedCountry.code).a;

                    if (phone.possibility !== "unknown") {
                        this.fullPhone = phone.number["e164"];
                        this.phoneValid = phone.valid;
                    }
                },
                immediate: true,
                deep: true
            },
            "addMember.phone": {
                handler: function(val) {
                    if (!this.selectedCountry) {
                        this.selectedCountry =
                            this.countries.find(country => country.dial_code === countries.data.find(country => country.name.toLowerCase() === "nigeria").dial_code);
                    }

                    const phone = new PhoneNumber(val, this.selectedCountry.code).a;

                    if (phone.possibility !== "unknown") {
                        this.fullPhone = phone.number["e164"];
                        this.phoneValid = phone.valid;
                    }
                }
            },
            "$props.members": {
                handler: function(val) {
                    this.memberList = val ? val : [];
                },
                deep: true,
                immediate: true
            }
        }
    }
</script>

<style scoped lang="scss">
    tr:not(:last-of-type) {
        border-bottom: 1px solid lightgray;
    }

    .btn-shell {
        background: none;
        border: none;
        height: auto;
        width:auto;
        margin: 0;
        padding: 0;
        outline: none;
        cursor: pointer;
    }

    .form-group {
        margin: 0 !important;
    }
</style>
<style scoped lang="scss" src="../../Auth/AuthModal/AuthModal.scss"></style>